(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const mcGuideMedia = window.matchMedia('(min-width: 900px)');

  const syncCollectionGuides = () => {
    document.querySelectorAll('.mc-guide-companion').forEach((guide) => {
      if (mcGuideMedia.matches) {
        guide.open = true;
      } else if (!guide.dataset.mcMobileReady) {
        guide.open = false;
        guide.dataset.mcMobileReady = 'true';
      }
    });
  };

  document.addEventListener('DOMContentLoaded', syncCollectionGuides, { once: true });
  mcGuideMedia.addEventListener('change', syncCollectionGuides);

  } catch(e) { console.error(e); }
})();
})();
